/* eslint max-len: ["error", 120]*/
import { Map } from 'immutable';

import Editor from './Editor';
import Designer from './Designer';
import Display from './Display';
import helpers from './helpers';

const MultiRelationshipSelect = {

  // Sub-components
  display: Display,
  designer: Designer,
  editor: Editor,

  // Prevent property value from being automatically saved
  skipAutoSave: true,

  // Used to save values when inline editor submits
  editSubmit(elementProp, dispatch, projectId, elementId, typeOptions) {
    return helpers.editSubmit(elementProp, dispatch, projectId, elementId, typeOptions);
  },

  // Used to create relationships when new element modal submits
  postCreate(elementProp, dispatch, projectId, elementIds, typeOptions) {
    return helpers.postCreate(elementProp, dispatch, projectId, elementIds, typeOptions);
  },

  // Gets value of property - used for comparison purposes by multi-edit
  getPropValue(elementProp, typeOptions, elementId, relationships, providesToConsumesFrom) {
    const ids = helpers.getElementIdsfromRelationships(elementId, typeOptions, relationships, providesToConsumesFrom);
    // console.log('getPropValue: ', ids, elementId, typeOptions);
    ids.sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return +1;
      return 0;
    });
    return ids.join(',');
  },

  getElementTypeIds(typeOptions1) {
    const typeOptions = Map.isMap(typeOptions1) ? typeOptions1.toJSON() : typeOptions1;
    let types = (typeOptions && typeOptions['[ET]element_type']) || [];
    if (typeof types === 'string') types = types.split(',');
    return types;
  },
};

export default MultiRelationshipSelect;



// WEBPACK FOOTER //
// ./src/components/types/RelationshipSelect/MultiRelationshipSelect.js